import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Button, Spinner, FormControl } from 'react-bootstrap';
import { strings } from '../../resources/strings';
import { ProviderCommand } from '../commands/ProviderCommand';
import { ScheduleCommand } from '../commands/ScheduleCommand';
import { TripCommand } from '../commands/TripCommand';
import { DocumentCommand } from '../commands/DocumentCommand';
import { lineInfoStopIcon } from '../leaflet/StopIcons';

import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from "leaflet";



export class Schedules extends Component {
    static contextTypes = {
        getState: PropTypes.func,
        setState: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.stateKey = "schedules";

        this.state = {
            commands: {
                provider: new ProviderCommand(),
                schedule: new ScheduleCommand(),
                trip: new TripCommand(),
                document: new DocumentCommand()
            },
            data: {
                scheduleInfo: {
                    stops: [],
                    trips: [],
                    exceptions: []
                },
                mapInfo: undefined,
                document: undefined
            },
            dependencies: {
                providers: [],
                lines: [],
                dayTypes: []
            },
            form: {
                provider: undefined,
                line: undefined,
                direction: undefined,
                dayType: undefined,
                selectedDay: undefined
            },
            render: {
                lineDropdown: false,
                directionDropdown: false,
                dayTypeDropdown: false,
                daysDropdown: false,
                disableDownloadButton: true
            },
            actions: {
                isLoadingProviders: false,
                isLoadingLines: false,
                isLoadingDayTypes: false,
                isLoadingInfo: false,
                isLoadingMapInfo: false,
                typing: false,
                typedText: ''
            },
            lineColor: undefined
        };
    }

    componentDidMount() {
        const { getState } = this.context;
        const state = getState(this.stateKey);

        if (undefined === state) {
            this.getProviderLines({
                id: 1,
                name: "UNIR",
                transportType: "Autocarros"
            });
        } else {
            this.setState(state);
        }
    }

    componentWillUnmount() {
        const { setState } = this.context;

        setState(this.stateKey, this.state);
    }

    //DATA
    getProviders() {
        const { commands, actions } = this.state;

        actions.isLoadingProviders = true;
        commands.provider.getProviders((r) => this.providersSuccessCallback(r));

        this.setState({
            actions: actions
        });
    }

    providersSuccessCallback(result) {
        const { dependencies, actions } = this.state;

        dependencies.providers = result;
        actions.isLoadingProviders = false;

        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    getProviderLines(provider) {
        const { commands, actions } = this.state;
        const providerName = undefined === provider || undefined === provider.name ? "" : provider.name;

        actions.isLoadingLines = true;
        commands.provider.getProviderLines(providerName, (r) => this.providerLinesSuccessCallback(r))

        this.setState({
            actions: actions
        });
    }

    providerLinesSuccessCallback(result) {
        const { dependencies, render, actions } = this.state;

        dependencies.lines = result;
        render.lineDropdown = true;
        render.directionDropdown = false;
        render.daysDropdown = false;
        actions.isLoadingLines = false;

        this.setState({
            dependencies: dependencies,
            render: render,
            actions: actions
        });
    }

    getDayTypes() {
        const { form, commands, actions } = this.state;

        actions.isLoadingDayTypes = true;
        commands.schedule.getScheduleByLineGroupByDayType(form.line.id, (r) => this.dayTypesSuccessCallback(r));

        this.setState({
            actions: actions
        });
    }

    dayTypesSuccessCallback(result) {
        const { dependencies, render, actions, form } = this.state;

        dependencies.dayTypes = result;
        render.dayTypeDropdown = true;
        actions.isLoadingDayTypes = false;
        if (result.length === 1) {
            form.dayType = result[0];
        }

        this.setState({
            dependencies: dependencies,
            render: render,
            actions: actions,
            form: form
        }, () => {
            if (result.length === 1) {
                this.getTrips();
                this.getLinePaths();
            }
        });
    }

    getTrips() {
        const { commands, form, actions } = this.state;

        if (!form.line || !form.line.id || !form.direction) {
            return;
        }

        const today = new Date().toISOString().split("T")[0];
        const selectedDay = form.selectedDay || today;

        // ensure state has a valid selectedDay
        if (!form.selectedDay) {
            form.selectedDay = selectedDay;
            this.setState({ form });
        }

        actions.isLoadingInfo = true;
        commands.trip.getTripsByLineAndDay(
            form.line.id,
            form.direction,
            form.selectedDay,
            (r) => this.getTripsSuccessCallback(r));

        this.setState({
            actions: actions
        });
    }

    getLinePaths() {
        const {commands, form, actions} = this.state;

        actions.isLoadingMapInfo = true;
        commands.provider.getLinePaths(form.line.id, form.direction, (r) => this.getLinePathsSuccessCallback(r));

        this.setState({
            actions: actions
        });
    }

    getTripsSuccessCallback(result) {
        const { data, actions } = this.state;

        data.scheduleInfo = result;
        actions.isLoadingInfo = false;

        this.setState({
            data: data,
            actions: actions
        });
    }

    getLinePathsSuccessCallback(result) {
        const { data, actions } = this.state;

        data.mapInfo = result;
        actions.isLoadingMapInfo = false;

        this.setState({
            actions: actions,
            data: data
        });
    }

    getLineScheduleDocument() {
        const { form } = this.state;

        if (undefined === form.line) {
            return;
        }

        const { commands } = this.state;

        commands.document.getLineDirectionScheduleDocument(
            form.line.code,
            form.direction,
            (a) => this.getLineScheduleDocumentSucccessCallback(a),
            () => this.getLineScheduleDocumentErrorCallback()
        );
    }

    getLineScheduleDocumentSucccessCallback(document) {
        const { data, render } = this.state;

        data.document = document;
        render.disableDownloadButton = false;

        this.setState({
            render: render
        });
    }

    getLineScheduleDocumentErrorCallback() {
        const { data, render } = this.state;

        data.document = undefined;
        render.disableDownloadButton = true;

        this.setState({
            render: render
        });
    }

    downloadLineScheduleDocument() {
        const { data } = this.state;

        if (undefined === data.document) {
            return;
        }

        const { commands } = this.state;

        commands.document.downloadLineScheduleDocument(
            data.document.name,
            (a) => this.downloadLineScheduleDocumentSuccessCallback(a, data.document.name)
        );
    }

    downloadLineScheduleDocumentSuccessCallback(blob, name) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, name);
    }

    //---------

    //EVENTS
    onTripClick(tripId) {
        if (undefined === tripId || null === tripId || "" === tripId) {
            return;
        }

        this.props.history.push({
            pathname: `/trip-info/${tripId}`,
            state: { lineColor: this.state.lineColor }
        });
    }

    onDownloadDocumentClick() {
        this.downloadLineScheduleDocument();
    }

    //---------

    //FUNCTIONS
    setProvider(provider) {
        const { data, form, render } = this.state;

        data.scheduleInfo = { stops: [], trips: [], exceptions: [] };
        form.provider = provider;
        form.line = undefined;
        form.direction = undefined;
        form.dayType = undefined;
        render.lineDropdown = false;
        render.directionDropdown = false;
        render.daysDropdown = false;

        this.setState({
            data: data,
            form: form,
            render: render
        }, () => {
            this.getProviderLines(provider);
        });
    }

    setLine(line) {
        const { data, form, render } = this.state;

        data.scheduleInfo = { stops: [], trips: [], exceptions: [] };
        data.document = undefined;

        form.line = line;
        form.dayType = undefined;

        render.directionDropdown = true;
        render.daysDropdown = false;

        const { r, g, b } = line.lineColorFormatted || {};
        if (r !== undefined && g !== undefined && b !== undefined) {
            const toHex = (v) => v.toString(16).padStart(2, '0');
            const hexColor = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
            this.setState({ lineColor: hexColor });
        }

        this.setState({
            data,
            form,
            render,
            typing: false,
            typedText: ''
        }, () => {
            // set default direction
            let defaultDir;
            if (line.directions && line.directions.length > 0) {
                if (line.directions.includes("G")) {
                    defaultDir = "G";
                } else if (line.directions.includes("C")) {
                    defaultDir = "C";
                } else {
                    defaultDir = line.directions[0];
                }
            }

            // set today’s date and default direction
            if (defaultDir) {
                this.setDirection(defaultDir);

                const today = new Date().toISOString().split("T")[0];
                this.setDay(today);
            }
        });
    }


    setDirection(direction) {
        const { data, form, render } = this.state;

        data.scheduleInfo = { stops: [], trips: [], exceptions: [] };
        form.direction = direction;
        render.daysDropdown = true;

        this.setState({
            data: data,
            form: form,
            render: render
        }, () => {
            this.getLineScheduleDocument();
            this.getLinePaths();

            // if a day is already selected, refresh trips
            if (form.selectedDay) {
                this.setDay(form.selectedDay);
            }
        });
    }

    setLineSearch(e) {
        const { form, render, data } = this.state;

        form.line = undefined;
        form.direction = undefined;
        form.dayType = undefined;

        render.lineDropdown = true;
        render.directionDropdown = false;
        render.daysDropdown = false;
        render.disableDownloadButton = true;

        data.scheduleInfo.stops = [];
        data.scheduleInfo.trips = [];
        data.scheduleInfo.stops.exceptions = [];

        this.setState({
            typing: true,
            typedText: e.target.value,
            form: form,
            data: data,
            render: render
        });
    }

    determineDirectionString(direction) {
        switch (direction) {
            case "G":
                return strings.directionGo;
            case "R":
                return strings.directionReturn;
            case "C":
                return strings.directionCircular;
            default:
                return "";
        }
    }

    setDayType(dayType) {
        const { data, form } = this.state;

        data.scheduleInfo = { stops: [], trips: [], exceptions: [] };
        form.dayType = dayType;

        this.setState({
            data: data,
            form: form
        }, () => {
            this.getTrips();
        });
    }

    setDay(day) {
        const { form } = this.state;
        form.selectedDay = day;

        this.setState({
            form: form
        }, () => {
            this.getTrips();
        })
    }

    calculateBounds() {
        const { data } = this.state;

        if (!data.mapInfo || data.mapInfo.length === 0) {
            return null;  
        } 

        let minLat = Infinity;
        let maxLat = -Infinity;
        let minLng = Infinity;
        let maxLng = -Infinity;

        data.mapInfo.forEach(path => {
            path.places.forEach(place => {
                const lat = place.coordX;
                const lng = place.coordY;

                minLat = Math.min(minLat, lat);
                maxLat = Math.max(maxLat, lat);
                minLng = Math.min(minLng, lng);
                maxLng = Math.max(maxLng, lng);
            });
        });

        return [[minLat, minLng], [maxLat, maxLng]];
    };

    //---------------

    //RENDER
    renderDropdowns() {
        return (
            <div>
                {this.renderLinesDropdown()}
                {this.renderDirectionsDropdown()}
                {this.renderDaysDropdown()}
            </div>
        );
    }

    renderLinesDropdown() {
        const { dependencies, form, render, actions } = this.state;

        if (actions.isLoadingLines) {
            return (
                <div className="width-100 text-align-center">
                    <Spinner animation="border" role="status" style={{ color: this.state.lineColor || "#4877FF" }} />
                </div>
            );
        }

        if (!render.lineDropdown) {
            return null;
        }

        const { typing, typedText } = this.state;

        return (
            <div className="schedules-lines-form margin-bottom-10">
                <div className="dropdown">
                    <FormControl
                        className="schedules-line-button"
                        id="lineDropdown"
                        placeholder={strings.line}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        autoComplete="off"
                        onChange={e => this.setLineSearch(e)}
                        value={
                            typing === false ?
                                form.line !== undefined ? form.line.code + ' ' + form.line.name
                                    : ''
                                : typedText
                        }
                        style={{
                            border: `2px solid ${this.state.lineColor || "#4877FF"}`
                        }}
                    />

                    <ul className="dropdown-menu schedules-line-dropdown-list" aria-labelledby="lineDropdown">
                        {
                            dependencies.lines
                                .filter(line => {
                                    const code = line.code || '';
                                    const goName = line.name || '';
                                    const searchText = typedText || '';
                                    return (code.toLowerCase() + ' ' + goName.toLowerCase()).indexOf(searchText.toLowerCase()) > -1;
                                })
                                .map((line, index) =>
                                    <li key={`line-${index}`} onClick={() => this.setLine(line)}>
                                        <span className="dropdown-item">
                                            <b>{line.code}</b>&nbsp;{line.name}
                                        </span>
                                    </li>
                                )
                        }
                    </ul>
                </div>
                <div className="download-button">
                    <Button variant="light" disabled={render.disableDownloadButton} onClick={() => this.onDownloadDocumentClick()}>
                        <span className="icon icon-download" />&nbsp;<span className="text">DOWNLOAD</span>
                    </Button>
                </div>
            </div>
        );
    }

    renderDirectionsDropdown() {
        const { form, render } = this.state;

        if (!render.lineDropdown) {
            return null;
        }

        return (
            <div className="dropdown margin-bottom-10">
                <Button variant="secondary" className="dropdown-toggle schedules-direction-button" id="directionDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    style={{
                        border: `2px solid ${this.state.lineColor || "#4877FF"}`
                    }}>
                    {
                        form.direction !== undefined ?
                            <span className="overflow-x-clip">{this.determineDirectionString(form.direction)}</span>
                            :
                            <span className="text-color-placeholder overflow-x-clip">{strings.direction}</span>
                    }
                </Button>
                <ul className="dropdown-menu schedules-direction-dropdown-list" aria-labelledby="directionDropdown">
                    {
                        form.line && form.line.directions ?
                            form.line.directions.map(direction =>
                                <li key={direction} onClick={() => this.setDirection(direction)}>
                                    <span className="dropdown-item">
                                        {this.determineDirectionString(direction)}
                                    </span>
                                </li>
                            )
                            :
                            null
                    }
                </ul>
            </div>
        );
    }

    renderDaytypesDropdown() {
        const { dependencies, form, render, actions } = this.state;

        if (actions.isLoadingDayTypes) {
            return (
                <div className="width-100 text-align-center">
                    <Spinner animation="border" role="status" style={{ color: this.state.lineColor || "#4877FF" }} />
                </div>
            );
        }

        if (!render.dayTypeDropdown) {
            return null;
        }

        return (
            <div className="dropdown margin-bottom-10">
                <Button variant="secondary" className="dropdown-toggle schedules-daytype-button" id="daytypeDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    {
                        form.dayType !== undefined ?
                            <span className="overflow-x-clip">{form.dayType.name}</span>
                            :
                            <span className="text-color-placeholder overflow-x-clip">{strings.daytype}</span>
                    }
                </Button>
                <ul className="dropdown-menu schedules-daytype-dropdown-list" aria-labelledby="daytypeDropdown">
                    {
                        dependencies.dayTypes.map(dayType =>
                            <li key={dayType.name} onClick={() => this.setDayType(dayType)}>
                                <span className="dropdown-item">
                                    {dayType.name}
                                </span>
                            </li>
                        )
                    }
                </ul>
            </div>
        );
    }

    renderDaysDropdown() {
        const { form, render } = this.state;

        if (!render.lineDropdown) {
            return null;
        }

        const today = new Date().toISOString().split("T")[0];
        const selectedDay = form.selectedDay || today;

        return (
            <div className="margin-bottom-10">
                <input
                    type="date"
                    className="btn btn-secondary schedules-daytype-button"
                    value={selectedDay}
                    onChange={(e) => this.setDay(e.target.value)}
                    lang="pt-PT"
                    style={{
                        border: `2px solid ${this.state.lineColor || "#4877FF"}`
                    }}
                />
            </div>
        );
    }

    renderExceptionList(scheduleInfo) {
        return (
            <div className="schedules-schedule-exception-info-list">
                {
                    scheduleInfo.exceptions.map(exception =>
                        <div key={exception}>
                            {exception}
                        </div>
                    )
                }
            </div>
        );
    }

    renderScheduleInfoExceptions(scheduleInfo) {
        if (0 === scheduleInfo.exceptions.length) {
            return null;
        }

        return (
            <div className="schedules-schedule-exception-info">
                &nbsp;
                {this.renderExceptionList(scheduleInfo)}
            </div>
        );
    }

    renderScheduleInfo() {
        const { data, actions, form } = this.state;

        if (actions.isLoadingInfo) {
            return (
                <div className="width-100 text-align-center">
                    <Spinner animation="border" role="status" style={{ color: this.state.lineColor || "#4877FF" }} />
                </div>
            );
        }

        if(!Array.isArray(data.scheduleInfo.stops) || !Array.isArray(data.scheduleInfo.trips)) {
            return (
                <div className="width-100 text-align-center">
                    <span>{strings.noInfoToShow}</span>
                </div>
            );
        }

        const hasExceptions = Array.isArray(data.scheduleInfo.exceptions) && 0 < data.scheduleInfo.exceptions.length;

        return (
            <div
                className="schedules-schedule-info"
                style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr",
                    gap: "1rem",
                    height: "100%",
                }}
            >
                <div className="schedules-schedule-info">
                    <div className="schedules-schedule-trip-info">
                        {this.renderStopsList(data.scheduleInfo, hasExceptions)}
                        {this.renderTripList(data.scheduleInfo, hasExceptions)}
                    </div>

                    {this.renderScheduleInfoExceptions(data.scheduleInfo)}
                </div>

                {form.line && form.direction ? (
                    actions.isLoadingMapInfo ? (
                        <div className="width-100 text-align-center" style={{ padding: "2rem" }}>
                            <Spinner animation="border" role="status" style={{ color: this.state.lineColor || "#4877FF" }} />
                            <p style={{ marginTop: "1rem", color: "#666" }}>A carregar o mapa...</p>
                        </div>
                    ) : (
                        <div className="schedule-map">
                            <MapContainer
                                center={[41.528, -7.99]}
                                zoom={13}
                                style={{ height: "100%", width: "100%" }}
                                whenCreated={(mapInstance) => {
                                    setTimeout(() => {
                                        const bounds = this.calculateBounds();
                                        if (bounds) {
                                            mapInstance.fitBounds(bounds, {
                                                padding: [30, 30],
                                                maxZoom: 16
                                            });
                                        }
                                    }, 100);
                                }}
                                zoomControl={false}
                                scrollWheelZoom={true}
                            >
                                <TileLayer
                                    url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png"
                                    attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors &copy; <a href='https://carto.com/attributions'>CARTO</a>"
                                />
                                    {data.mapInfo && data.mapInfo.map(path => (
                                        <React.Fragment key={path.id}>
                                            <Polyline
                                                positions={
                                                    path.shape && Array.isArray(path.shape.segments?.[0]?.breakpoints) && path.shape.segments[0].breakpoints.length > 0
                                                        ? path.shape.segments[0].breakpoints.map(bp => [bp.latitude, bp.longitude])
                                                        : path.places.map(p => [p.coordX, p.coordY])
                                                }
                                                pathOptions={{
                                                    color: this.state.lineColor || "#4877FF",
                                                    weight: 4,
                                                    opacity: 0.8,
                                                    smoothFactor: 1.0
                                                }}
                                            />

                                            {path.places.map((place) => (
                                                <Marker
                                                    key={place.id}
                                                    position={[place.coordX, place.coordY]}
                                                    icon={lineInfoStopIcon}
                                                >
                                                    <Popup>
                                                        <div style={{ minWidth: '120px' }}>
                                                            <strong style={{ color: '#333', fontSize: '14px' }}>
                                                                {place.name} ({place.code})
                                                            </strong>
                                                        </div>
                                                    </Popup>
                                                </Marker>
                                            ))}
                                        </React.Fragment>
                                    ))}
                            </MapContainer>
                        </div>
                    )
                ) : null}
            </div>
        );

    }

    renderStopsList(scheduleInfo, hasExceptions) {
        return (
            <div className="schedules-schedule-stop-info">
                {hasExceptions ? <div>&nbsp;</div> : null}
                {
                    scheduleInfo.stops.map(stop =>
                        <div key={`${stop.name}-${stop.order}`} title={stop.name}>
                            {stop.name}
                        </div>
                    )
                }
            </div>
        );
    }

    renderTripList(scheduleInfo, hasExceptions) {
        return (
            <div className="schedules-schedule-passing-info">
                {
                    scheduleInfo.trips.map((trip, index) => {
                        const firstPassing = trip[0];
                        let tripId = undefined;
                        if ("object" === typeof firstPassing) {
                            tripId = firstPassing.tripId;
                        }

                        return (
                            <div key={`${trip.stopId}-${index}`} className="schedules-schedule-passing-info-list" onClick={() => this.onTripClick(tripId)}>
                                {hasExceptions ? this.renderTripExceptions(trip) : null}
                                {this.renderTripPassings(trip, scheduleInfo.stops)}
                            </div>
                        );
                    })
                }
            </div >
        );
    }

    renderTripExceptions(trip) {
        const exceptions = trip
            .filter(passing => Array.isArray(passing.exceptions) && 0 < passing.exceptions.length)
            .reduce((output, passing) => {
                passing.exceptions.forEach(exception => {
                    if (!output.includes(exception)) {
                        output.push(exception);
                    }
                });
                
                return output;
            }, []).sort((a, b) => a.localeCompare(b)).join(", ");

        return (
            <div className="white-space-no-wrap">
                {"" === exceptions ? <span>&nbsp;</span> : exceptions.toUpperCase()}
            </div>
        );
    }

    renderTripPassings(trip, stops) {
        let isFirstPassing = true;

        return stops.map(stop => {
            const passing = trip.find(passing => passing.stopId === stop.id && passing.stopOrder === stop.order);
            if (undefined === passing) {
                return (
                    <div key={`undefined-time-${trip.order}-${stop.id}-${stop.order}`} className="schedules-trip-passing-list-empty-value">
                        --:--
                    </div>
                );
            }

            const output = (
                <div key={`time-${trip.order}-${stop.id}-${stop.order}-${passing.time}`} className={`schedules-trip-passing-list-value ${isFirstPassing ? "first-passing" : ""}`}>
                    {passing.time}{passing.exceptionIdentifier}
                </div>
            );
            isFirstPassing = false;

            return output;
        });
    }

    render() {
        return (
            <div className="schedules-panel">
                {this.renderDropdowns()}
                {this.renderScheduleInfo()}
            </div>
        );
    }
}
